import { useEffect, useMemo } from "react";
import { ArrowHelper, Vector3 as ThreeVector3 } from "three";
import type { Material } from "three";
import { SUNLIGHT_TRAVEL_DIRECTION } from "../simulation/constants";

interface Disposable {
  dispose: () => void;
}

function addMaterials(
  resources: Set<Disposable>,
  material: Material | Material[],
) {
  const materials = Array.isArray(material) ? material : [material];
  for (const ownedMaterial of materials) {
    resources.add(ownedMaterial);
  }
}

export function useSunlightArrows(
  origins: readonly (readonly [number, number, number])[],
): readonly ArrowHelper[] {
  const arrows = useMemo(() => {
    const direction = new ThreeVector3(...SUNLIGHT_TRAVEL_DIRECTION);
    return origins.map((origin) => {
      const arrow = new ArrowHelper(
        direction,
        new ThreeVector3(...origin),
        30,
        0xffd166,
        0.55,
        0.25,
      );
      arrow.line.geometry = arrow.line.geometry.clone();
      arrow.cone.geometry = arrow.cone.geometry.clone();
      return arrow;
    });
  }, [origins]);

  useEffect(
    () => () => {
      const resources = new Set<Disposable>();
      for (const arrow of arrows) {
        resources.add(arrow.line.geometry);
        addMaterials(resources, arrow.line.material);
        resources.add(arrow.cone.geometry);
        addMaterials(resources, arrow.cone.material);
      }
      for (const resource of resources) {
        resource.dispose();
      }
    },
    [arrows],
  );

  return arrows;
}
